<!-- @format -->
<occupations>
  <style>
    ul.checkbox_list {
      display: flex;
      flex-wrap: wrap;
    }
  </style>

  <div class="box_flex03 margin-spacing-4_bottom">
    <p class="heading-04">職種を検索する</p>
    <div class="box_w50 margin-spacing-2_left margin-spacing-2_right">
      <input
        class="text_input"
        type="text"
        name="searchWord"
        autocomplete="off"
        placeholder="職種を入力"
      />
    </div>
    <div
      class="button button-secondary js-modal-open"
      type="button"
      value="検索"
      onclick="{ onSearchOccupations }"
    >
      検索
    </div>
  </div>

  <div class="container_accordion" each="{ major in props.master }">
    <div class="accordion_heading is-hide" data-group="{ major.id }">
      <div class="checkbox_wrap">
        <input
          type="checkbox"
          id="major_group_id_{ major.id }"
          class="checkbox-input"
          value="{ major.id }"
          onclick="{ onCheckMajor }"
        />
        <label for="major_group_id_{ major.id }" class="checkbox-parts">
          { major.name }
        </label>
      </div>
      <div class="js-accordion"></div>
    </div>
    <!--/.accordion_heading-->

    <div class="accordion_body" data-group="{ major.id }" style="display: none">
      <template each="{ (minor,index )in major.list }">
        <div
          class="accordion_heading02 { index ? 'margin-spacing-4_top' : '' }"
        >
          <div class="checkbox_wrap">
            <input
              type="checkbox"
              id="minor_group_id_{minor.id}"
              value="{ minor.id }"
              onclick="{ onCheckMinor }"
              class="checkbox-input"
            />
            <label for="minor_group_id_{ minor.id }" class="checkbox-parts">
              { minor.name }
            </label>
          </div>
        </div>

        <ul class="checkbox_list margin-spacing-1_top">
          <template each="{ unit in minor.list }">
            <li class="checkbox_list-item">
              <input
                type="checkbox"
                name="unit_id_{ unit.id }"
                value="{ unit.id }"
                checked="{ props.data.isChecked(unit.id) }"
                id="unit_group_id_{ unit.id }"
                class="checkbox-input media-publication"
                onclick="{ onCheckUnit }"
              />
              <label for="unit_group_id_{ unit.id }" class="checkbox-parts">
                { unit.name }
              </label>
            </li>
          </template>
        </ul>
      </template>
    </div>
    <!--/.accordion_body-->
  </div>

  <search-modal
    modal-id="occupations-modal"
    is-open="{ state.searchModalIsOpen }"
    on-close="{ e => update({searchModalIsOpen: false}) }"
    data="{ props.data }"
    errors="{{}}"
    groups="{ state.groups }"
    on-check="{ onCheckUnit }"
    on-submit="{ onSubmit }"
    caption="職種"
  ></search-modal>

  <script>
    import di from "dependency-injection";
    import modal from "@tags/modal/search-modal.riot";

    // ひらがな -> カタカナ
    const hToK = (str) =>
      str.replace(/[\u3041-\u3096]/g, (c) =>
        String.fromCharCode(c.charCodeAt(0) + 0x60)
      );

    export default {
      components: {
        "search-modal": modal,
      },
      state: {
        searchModalIsOpen: false,
        groups: [],
      },
      onMounted(props, state) {
        window.$(this.$('[name="searchWord"]')).autocomplete({
          source: (request, response) => {
            const groups = this.searchGroup(request.term);
            this.update({ groups });
            response(
              groups.reduce((a, c) => {
                return a.concat(c.list.map((e) => e.match));
              }, [])
            );
          },
        });
        for (const id of props.data.getCheckedGroup(props.master)) {
          this.$(`[data-group="${id}"].accordion_heading`).classList.remove(
            "is-hide"
          );
          this.$(`[data-group="${id}"].accordion_body`).style.display = "block";
        }
      },
      searchGroup(text) {
        const findName = text.toUpperCase();
        const findKana = hToK(text);
        const reducer = (a, c) => {
          if (c.name.toUpperCase().match(findName)) {
            a.push({ id: c.id, name: c.name, match: c.name });
          } else if (c.kana.match(findKana)) {
            a.push({ id: c.id, name: c.name, match: c.kana });
          }
          return a;
        };
        let groups = [];
        for (const group of this.props.master) {
          let list = group.list.reduce((a, c) => {
            if (c.list) {
              return a.concat(c.list.reduce(reducer, []));
            } else {
              return reducer(a, c);
            }
          }, []);
          if (list.length > 0) {
            groups.push({ name: group.name, list });
          }
        }
        return groups;
      },
      onSearchOccupations() {
        const searchWord = this.$('[name="searchWord"]').value;
        if (searchWord === "") {
          di.toast.push("検索内容が入力されていません", "negative");
          return;
        }
        this.update({
          searchWord,
          groups: this.searchGroup(searchWord),
          searchModalIsOpen: true,
        });
      },
      onCheckMajor(e) {
        const major = this.props.master.find((m) => m.id == e.target.value);
        for (const minor of major.list) {
          this.$(`#minor_group_id_${minor.id}`).checked = e.target.checked;
          for (const unit of minor.list) {
            this.props.data.update(unit.id, e.target.checked);
          }
        }
        this.props.onCheck(this.props.data);
      },
      onCheckMinor(e) {
        for (const major of this.props.master) {
          for (const minor of major.list) {
            if (minor.id == e.target.value) {
              for (const unit of minor.list) {
                this.props.data.update(unit.id, e.target.checked);
              }
              break;
            }
          }
        }
        this.props.onCheck(this.props.data);
      },
      onCheckUnit(e) {
        this.props.data.update(e.target.value, e.target.checked);
        this.props.onCheck(this.props.data);
      },
      async onSubmit(e) {
        if (this.props.onSubmit()) {
          this.update({ searchModalIsOpen: false });
        }
      },
    };
  </script>
</occupations>
